<script>
  import { createEventDispatcher } from 'svelte';

  export let caption;
  export let headerList;
  export let rowList;
  export let sortAttr;
  export let sortAscending;

  // Table row limit
  const limit = 10;
  let showAll = false;

  const dispatch = createEventDispatcher();

  // flip the toggle on each click
  function onToggle() {
    showAll = !showAll;
  }
  function onSort(e) {
    const thisAttr = e.target.getAttribute('data-attr');
    if (thisAttr) {
      dispatch('sortTable', {
        attr: thisAttr,
      });
    }
  }
</script>

<table class="dg-table">
  <caption>{caption}</caption>
  <thead>
    <tr>
      {#each headerList as obj}
        <th
          scope="col"
          data-attr={obj.attr}
          class={obj.class}
          class:sort-asc={obj.attr && sortAttr === obj.attr && sortAscending}
          class:sort-desc={obj.attr && sortAttr === obj.attr && !sortAscending}
          on:click={onSort}
        >
          {obj.text}
        </th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each rowList as obj, idx}
      <tr class:display-none={idx + 1 > limit && !showAll}>
        <th scope="col" class={obj.class}>
          {@html obj.text}
        </th>
        {#each obj.values as column}
          <td class={column.class}>
            {@html column.text}
          </td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>
<div class="text-center">
  <button class="btn" on:click={onToggle}>
    {showAll ? 'Show less' : 'Show all'}
  </button>
</div>
